import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {catchError, map} from 'rxjs/operators';
import {Observable, of, throwError} from 'rxjs';
import {ValidationErrorResponse} from '../../shared/models/validation-error-response';
import {DomainNameParserService} from '../../shared/services/domain-name-parser.service';
import { ThrowStmt } from '@angular/compiler';

@Injectable({
  providedIn: 'root'
})
export class RegistrationDataValidationService {

  private readonly serviceLayerHost;
  private readonly USERNAME_VALIDATION_PATH = '/public/v1/dearborn/users/validations/username';
  private readonly PASSWORD_VALIDATION_PATH = '/public/v1/dearborn/users/validations/password';

  constructor(private http: HttpClient, private domainNameParserService: DomainNameParserService) {
    this.serviceLayerHost = environment.serviceLayer.host[domainNameParserService.getState()];
  }

  validateUsername(username: string): Observable<ValidationErrorResponse> {
      return this.http.post<ValidationErrorResponse>(this.createValidationUsernameUrl(), null, {
        headers: new HttpHeaders()
          .set('Content-Type', 'application/json')
          .set('Accept', 'application/json')
          .set('username', username),
        observe: 'response'
      }).pipe(
        map(_ => {
          return null;
        }),
        catchError((err: HttpErrorResponse) => {
          if (err.status === 422) {
            return of(JSON.parse(err.error.message));
          } else {
            console.error('Server returned error response. Details: ' + JSON.stringify(err));
            return throwError('Cannot parse response from SL server.');
          }
        })
      );
    }

  validatePassword(password: string): Observable<ValidationErrorResponse> {
    return this.http.post<ValidationErrorResponse>(this.createValidationPasswordUrl(), null, {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set('Accept', 'application/json')
        .set('password', password),
      observe: 'response'
    }).pipe(
      map(_ => {
        return null;
      }),
      catchError((err: HttpErrorResponse) => {
        if (err.status === 422) {
          return of(JSON.parse(err.error.message));
        } else {
          console.error('Server returned error response. Details: ' + JSON.stringify(err));
          return throwError('Cannot parse response from SL server.');
        }
      })
    );
  }

  private createValidationUsernameUrl(): string {
//    return this.serviceLayerHost + this.USERNAME_VALIDATION_PATH;
     return "validateUser";
  }

  private createValidationPasswordUrl(): string {
    // return this.serviceLayerHost + this.PASSWORD_VALIDATION_PATH;
    return "validatePassword";
  }
}
